import URL from "core/resources/urls";
import http from "infra/http";
import { useQuery } from "react-query";

const useOcupacoes = () => {
  return useQuery(
    [URL.OCUPACOES.OBTER],
    async () => {
      const response = await http.get(URL.OCUPACOES.OBTER, {
        params: {
          exibir: true,
        },
      });

      return response?.data as any[];
    },
  );
};

export default useOcupacoes;
